import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { ActividadComercial } from "@/shared/types/actividad-comercial";

export interface ActividadComercialAddRequest {
  codigo: string,
  nombre: string,
}

export async function addActividadComercial(request: ActividadComercialAddRequest): Promise<ActividadComercial> {
  await sleep(1000);
  const response = await api.post("actividades_comerciales", request);
  return response.data;
}

export function useAddActividadComercialMutation(mutationConfig: MutationConfig<ActividadComercial, ActividadComercialAddRequest> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    ...mutationConfig,
    mutationFn: addActividadComercial,
    onSuccess: (...args) => {
      mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
      queryClient.invalidateQueries({ queryKey: ["actividades_comerciales"] });
    },
  })
}

export interface AddActividadComercialMutationProps {
  mutationConfig?: MutationConfig<ActividadComercial, ActividadComercialAddRequest>
  children: (mutationResult: MutationResult<ActividadComercial, ActividadComercialAddRequest>) => ReactNode
}

export function AddActividadComercialMutation({
  mutationConfig,
  children
}: AddActividadComercialMutationProps) {
  const mutation = useAddActividadComercialMutation(mutationConfig);
  return children(mutation);
}
